import { CubismFramework, Option } from '@framework/live2dcubismframework';
import { LAppPal } from './Live2D/lapppal';
import * as LAppDefine from './Live2D/lappdefine';
import { LAppSubdelegate } from './Live2D/lappsubdelegate';
import { CubismLogError } from '@framework/utils/cubismdebug';

let started = false;
let subdelegate: LAppSubdelegate | null = null;
let running = false;
const state = {
  audio: new Audio(),
  speakId: 1 // increment it to stop current utterance
}
//let audio : null | HTMLAudioElement = null; // to cancel current utterance

export async function init() {
  LAppPal.updateTime();
  
  // setup cubism
  const cubismOption = new Option();
  cubismOption.logFunction = LAppPal.printMessage;
  cubismOption.loggingLevel = LAppDefine.CubismLoggingLevel;
  CubismFramework.startUp(cubismOption);

  // initialize cubism
  CubismFramework.initialize();
}

export async function start(canvas: HTMLCanvasElement | null) {
  if (!canvas) return;
  if (started) return;
  console.log("START")

  subdelegate = new LAppSubdelegate();

  //canvas.style.width = `25vh`; // make it a square!
  //canvas.style.height = `50vh`;
  //canvas.style.bottom = '10vh'
  //canvas.style.right = '0'

  subdelegate.initialize(canvas);

  if (subdelegate.isContextLost()) {
    CubismLogError(
      `The context for Canvas at index 0 was lost, possibly because the acquisition limit for WebGLRenderingContext was reached.`
    );
  }

  running = true;
  const loop = (): void => {
    if (!running) return;
    if (!subdelegate) return;

    LAppPal.updateTime();
    subdelegate.update();

    requestAnimationFrame(loop);
  };
  loop();

  // warmup audio so we have audio object from user interaction (required for ios safari)
  const model = subdelegate.getLive2DManager()._models.at(0)
  model._wavFileHandler.start("data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA", state)

  started = true;
}

export function stop() {
  console.log(running, started, subdelegate)
  if (!running) return;
  running = false;
  if (!started) return;

  if (!subdelegate) return;
  console.log("STOP")
  subdelegate.release();

  started = false;
}

export function isRunning() {
  return started;
}

const speakSafeExpressions = ["F01", "F04", "F06", "F07", "F08"]
const idleExpressions = ["F01", "F04", "F05", "F06", "F07", "F08"]
const speakUnsafeExpressions = ["F02", "F03", "F05"]

export function stopSpeaking() {
  state.speakId += 1
  state.audio.pause()

  // reset lip animation
  setTimeout(() => {
    // NOTE: We do this cleanup in a setTimeout because pause() should first trigger
    // onpause handler for audio, so that other things that depends on audio ending should fire first.
    if (!started) return;
    if (!subdelegate) return;
    const model = subdelegate.getLive2DManager()._models.at(0)
    //model._wavFileHandler.start("data:audio/wav;base64,UklGRhQAAABXQVZFZm10IBAAAAABAAEAAQAAACAAABAAZGF0YQAAAAAA", state)
    model._wavFileHandler.start("data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA", state)
  }, 0)
}

export async function speak(lang: string, text: string) {
  if (!started) return;
  if (!subdelegate) return;

  //const url = `https://tts.soclearn.org/?lang=${encodeURIComponent(lang)}&text=${encodeURIComponent(text)}`
  //await new Promise(resolve => {model._wavFileHandler.start(url, () => resolve(true))})


  // streaming tts
  randomSpeakExpression()

  const response = await fetch("https://tts.soclearn.org/stream", {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          language: lang,
          text
      })
  });

  const reader = response.body!.getReader();
  const decoder = new TextDecoder();
  let done = false;
  let buffer = '';

  const thisSpeakId = state.speakId;
  while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;
      if (value) {
          buffer += decoder.decode(value, { stream: true });
          // Ollama streams JSON objects separated by newlines
          let lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (const line of lines) {
            if (thisSpeakId != state.speakId) return;
            if (line.trim()) {
                const data = JSON.parse(line);
                if (!data.done) {
                  if (!started) return;
                  const model = subdelegate.getLive2DManager()._models.at(0)
                  console.log("SPEAK PART START")
                  await new Promise(resolve => {model._wavFileHandler.start(data.voice, state, () => resolve(true))})
                  console.log("SPEAK PART END")
                }
                //console.log(data);
            }
          }
      }
  }

  // after speaking only!
  randomIdleExpression();
}

export async function randomMotion() {
  if (!started) return;
  if (!subdelegate) return;
  const model = subdelegate.getLive2DManager()._models.at(0)
  
  model.startRandomMotion(
    LAppDefine.MotionGroupTapBody,
    LAppDefine.PriorityNormal,
    console.log,
    console.log
  );
}

export async function randomExpression() {
  if (!started) return;
  if (!subdelegate) return;
  const model = subdelegate.getLive2DManager()._models.at(0)

  //console.log(model._expressions)
  model.setRandomExpression();
  //model.setExpression("F07")
}

export async function setExpression(expression: string) {
  if (!started) return;
  if (!subdelegate) return;
  const model = subdelegate.getLive2DManager()._models.at(0)

  //console.log(model._expressions)
  //model.setRandomExpression();
  model.setExpression(expression)
}

export async function randomSpeakExpression() {
  setExpression(speakSafeExpressions[Math.floor(Math.random() * speakSafeExpressions.length)])
}

export async function randomIdleExpression() {
  setExpression(idleExpressions[Math.floor(Math.random() * idleExpressions.length)])
}

export default { init, start, stop, isRunning, speak, stopSpeaking, randomMotion, randomExpression }
